import React from 'react';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import servicioUsuario from '../servicios/ServicioUsuario';
export class Usuario extends React.Component {
    constructor() {
        super();
        this.state = {
            errores: {},
            paginacion: { registrosPorPagina: 20 },
            inicio: 0,
        }
    }
    componentDidMount() {
        this.obtenerPagina();
    }
    cambiaPagina(event) {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }
    obtenerPagina() {
        let { paginacion } = this.state;
        servicioUsuario.paginacion(paginacion).then((response) => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

            if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });
    }
    formatoEstatus(column) {
        if (column.estatus === 1)
            return <div>{"Activo"}</div>
        if (column.estatus === 0)
            return <div>{"Inactivo"}</div>
        if (column.estatus === 2)
            return <div>{"Desactivado"}</div>
    }
    componentWillUnmount() { }
    render() {
        let { paginacion, inicio } = this.state;
        return (
            <div className="content-section implementation">
                <Growl ref={(el) => this.growl = el} />
                <div className="card card-w-title">
                    <h1>Mis Usuarios</h1>
                </div>
                <div className="content-section implementation">
                    <DataTable value={paginacion.datos} editable={true} selectionMode="single" scrollable={true} resizableColumns={true} responsive={true}>
                        <Column field="usuario" header="Usuario" />
                        <Column field="estatus" body={this.formatoEstatus.bind(this)} header="Estatus" />
                    </DataTable>
                    <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                </div>
            </div>
        );
    }
}
